import TradingViewChart from "../components/tradingViewChart";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronCircleRight, faArrowCircleRight } from "@fortawesome/free-solid-svg-icons";

import "../style/DJ15Token_landing.css";
import "../style/DJ15Responsive.css";
import mouse_ico from "../assets/mouse_ico.svg";
import about_Image from "../assets/about_Image.svg";
import uniswap_logo from "../assets/uniswap-logo.svg";
import wallet_logo from "../assets/wallet_logo.svg";
import coins_logo from "../assets/coins_logo.svg";
import qa_img_2 from "../assets/q&a_img_2.svg";
import qa_img from "../assets/q&a_img.svg";
import plus from "../assets/plus.svg";
import Logo_Big from "../assets/Logo_Big.svg";

import { Link } from "react-router-dom";

export default function Home() {
  return (
    <div className="container-fluid" style={{ minWidth: "390px", maxWidth: "1080px" }}>
      <div className="row">
        <div className="col">
          <div className="title-section">
            <div className="title-group">
              <div className="title">
                <h1>
                  BELIEVE IN{" "}
                  <span className="special-word">
                    <span className="floating-top">G</span>
                    <span className="floating-bottom">C</span>CHAN E
                  </span>
                </h1>
              </div>
              <div className="text-center">
                <a href="https://app.uniswap.org/swap?inputCurrency=ETH&amp;outputCurrency=0x5d269fac3b2e0552b0f34cdc253bdb427682a4b9" class="btn token-button">
                  GET DJ15{" "}
                  <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="circle-chevron-right" class="svg-inline--fa fa-circle-chevron-right " role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                    <path fill="currentColor" d="M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM241 377c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l87-87-87-87c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L345 239c9.4 9.4 9.4 24.6 0 33.9L241 377z"></path>
                  </svg>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col">
          <div className="burnmsg-section">
            <h1>Join to our exclusive DavinciJ15 Token Telegram Group!</h1>
            <div className="text-center">
              <Link to="/join" className="btn token-button">
                Join Now <FontAwesomeIcon icon={faArrowCircleRight} />
              </Link>
            </div>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col">
          <div className="microdj15-section">
            <h1>Give our new Testnet MicroDJ15 token playground a try!</h1>
            <div className="text-center">
              <a href="https://test-microdj15.davincij15.com/" className="btn token-button">
                Test MicroDJ15 <FontAwesomeIcon icon={faArrowCircleRight} />
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col">
          <div className="about-section">
            <div className="title">
              <h2>
                ABOUT <span className="token-red">DJ15</span> TOKEN
              </h2>
              <div className="underscore-line"></div>
            </div>
            <div className="content">
              <img src={about_Image} />
              <p>
                The DJ15 token was created by <b>software developer</b> and <b>crypto Youtuber Davinci Jeremie</b>; launched on August 16, 2020, and <b>announced on Twitter</b> the same day. <br />
                <br />
                The idea behind the creation of the <b>DJ15 token</b>, is to fundraise for the <b>DavinciJ15 YouTube</b> channel, improving the content and video quality presented to its YouTube subscribers. It provides us more freedom to develop content for the crypto community on our YouTube channel and on diverse platforms, such as Twitter and Twitch, among others, where you can find DavinciJ15 content. <br />
                <br />
                <b>2.1 million</b> coins were originally produced; however, we are committed to selling only thirty thousand tokens. We will be <b>reducing the total amount</b> available for use to <b>240,000 tokens</b>, burning the remaining amount. The <b>DJ15 Token</b> can be purchased on <b>Uniswap</b>, and it can be stored on <b>Pandora's Wallet, Metamask,</b> among others, or on any hardware wallet.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col">
          <div className="howto-section">
            <div className="text-center">
              <h1>
                HOW <span className="token-green">IT</span> WORKS?
              </h1>
            </div>
            <div className="row card-section">
              <div className="col">
                <div className="card h-100" id="uniswap">
                  <img className="card-img-top" src={uniswap_logo} alt="Uniswap" />
                  <div className="card-body d-flex flex-column">
                    <div className="mt-auto">
                      <h5 className="card-title">Purchase:</h5>
                      <p className="card-text">Uniswap is a decentralized exchange protocol built on Ethereum. To be more precise, it is an automated liquidity protocol. DJ15 token is available there or any other text here.</p>
                    </div>
                  </div>
                  <div className="card-footer text-center">
                    <a href="https://v2.info.uniswap.org/pair/0x6a164da2cdae5f1836c8fe6d683c3df4a0a65e5c" className="btn token-button">
                      Go to Uniswap
                    </a>
                  </div>
                </div>
              </div>
              <div className="col">
                <div className="card h-100" id="wallet">
                  <img className="card-img-top" src={wallet_logo} alt="Pandora's Wallet" />
                  <div className="card-body d-flex flex-column">
                    <div className="mt-auto">
                      <h5 className="card-title ">Storage:</h5>
                      <p className="card-text ">DJ15 token can be stored on Pandora's Wallet (a multi-cryptocurrency virtual wallet, which enables you to connect to various exchanges), Metamask, or on any hardware wallet.</p>
                    </div>
                  </div>
                  <div className="card-footer text-center">
                    <a href="https://www.metamask.io/" className="btn token-button">
                      Visit Metamask Site
                    </a>
                  </div>
                </div>
              </div>
              <div className="col">
                <div className="card h-100" id="analytics">
                  <img className="card-img-top" src={coins_logo} alt="Analytics" />
                  <div className="card-body d-flex flex-column">
                    <div className="mt-auto">
                      <h5 className="card-title">Business model:</h5>
                      <p className="card-text">12.5% of all media revenue generated will be used to purchase tokens that will later be burnt; thus, creating scarcity and possibly increasing the value of the token.</p>
                    </div>
                  </div>
                  <div className="card-footer text-center">
                    <a href="https://www.chartex.pro/?symbol=UNISWAP%3ADJ15.82A4B9%2FWETH&interval=240&theme=Dark" className="btn token-button">
                      Go to Protocol Analytics
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="row youtube-videos">
              <div className="col text-center">
                <iframe height="328" src="https://www.youtube.com/embed/Jy8O50LNpqU" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                <h3>How to buy DJ15 Token</h3>
                <p className="mx-auto">Where you can get the DJ15 token source, explained by Davinci. This social token is to will be used to gain special access in the future.</p>
              </div>
              <div className="col text-center">
                <iframe height="328" src="https://www.youtube.com/embed/zZzboodjIyU" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                <h3>How to enter the DJ15 Token telegram group</h3>
                <p className="mx-auto">
                  This is a step by step guide to signing (and verifying) a message in order to enter the Telegram Group. To enter the DJ15 Token telegram group you must have at least 0.05 DJ15 and speak to the bot found at this link:{" "}
                  <a className="text-white" href="https://t.me/DavinciJ15TokenBot">
                    TokenBot
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col">
          <div className="faq-section">
            <img src={qa_img_2} />
            <div className="title">
              <h2>
                QUESTIONS <span className="token-red">&amp;</span> ANSWERS
              </h2>
              <div className="underscore-line"></div>
            </div>
            <div className="content">
              <img className="img-content" src={qa_img} />
              <div className="accordeon">
                <div className="sub">
                  <div className="tittle">
                    <div className="icon-container ">
                      <div className="line mx-auto"></div>
                      <img className="plus-img mx-auto" src={plus} />
                    </div>
                    <p className="tittle-text">What are we going to do with 210,000 tokens left if you are only selling 30,000 tokens?</p>
                  </div>
                  <div className="info">
                    <p className="info">We Plan to use it anyway we see fit in order to improve our video content and the team behind it</p>
                  </div>
                </div>
                <div className="sub">
                  <div className="tittle">
                    <div className="icon-container ">
                      <div className="line mx-auto"></div>
                      <img className="plus-img mx-auto" src={plus} />
                    </div>
                    <p className="tittle-text">What is burning a token?</p>
                  </div>
                  <div className="info">
                    <p className="info">
                      This means you send a token to an addres that no one has acess to, thus those tokens sent will be lost forever. Our burn address is: <a href="https://etherscan.io/address/0x0000000000000000000000000000dead">0x0000000000000000000000000000dead</a>
                      <br />
                    </p>
                  </div>
                </div>
                <div className="sub">
                  <div className="tittle">
                    <div className="icon-container ">
                      <div className="line mx-auto"></div>
                      <img className="plus-img mx-auto" src={plus} />
                    </div>
                    <p className="tittle-text">Will you be listing the DJ15 token on other exchanges?</p>
                  </div>
                  <div className="info">
                    <p className="info">At the time we will only be using decentralized exchanges</p>
                  </div>
                </div>
                <div className="sub">
                  <div className="tittle">
                    <div className="icon-container ">
                      <div className="line mx-auto"></div>
                      <img className="plus-img mx-auto" src={plus} />
                    </div>
                    <p className="tittle-text">What is the exit strategy for this token?</p>
                  </div>
                  <div className="info">
                    <p className="info">At some point in the future we plan to buy all the tokens back at a fixed market price.</p>
                  </div>
                </div>
                <div className="sub">
                  <div className="tittle">
                    <div className="icon-container ">
                      <div className="line mx-auto"></div>
                      <img className="plus-img mx-auto" src={plus} />
                    </div>
                    <p className="tittle-text">What are the benefits of holding a DJ15 Token?</p>
                  </div>
                  <div className="info">
                    <p className="info"> You gain acess to our private DJ15 telegram group, Acces live streams, Interact with DavinciJ15, Possible profits from the token </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col">
          <div className="chart-section">
            <div className="map-bg-group">
              <div className="content">
                <h1>
                  DJ15 <span className="token-green">CHART</span> PRICE
                </h1>
                <p>Up to date graphical information about the pricing, liquidity and financial movement of the DJ15 Token.</p>
                <TradingViewChart />
                {/* <!-- <iframe src="https://www.chartex.pro/?symbol=UNISWAP%3ADJ15.82A4B9%2FWETH&interval=240&theme=Dark" title="DJ15 Token Chart"></iframe>  --> */}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col">
          <div className="address-section">
            <div className="text-center">
              <img src={Logo_Big} />
              <h2>0x5d269fac3b2e0552b0f34cdc253bdb427682a4b9</h2>
              <div className="btn-buynow">
                <a href="https://app.uniswap.org/swap?inputCurrency=ETH&outputCurrency=0x5d269fac3b2e0552b0f34cdc253bdb427682a4b9" className="btn token-button">
                  GET DJ15 <FontAwesomeIcon icon={faChevronCircleRight} />
                </a>
              </div>
              <div className="mb-1">
                <a href="https://www.geckoterminal.com/eth/pools/0x6a164da2cdae5f1836c8fe6d683c3df4a0a65e5c">Go to GeckoTerminal &gt; </a>
              </div>
              <div>
                <a href="https://etherscan.io/address/0x5d269fac3b2e0552b0f34cdc253bdb427682a4b9">Go to Etherscan &gt;</a>
              </div>
            </div>
            <div className="bg-text">
              <h1>ADDRESS</h1>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
